import React from "react";
import { Link } from 'react-router-dom';
import "./Team.css"

const Team = () => {
    return (
        <section className="py-5 bg-light" id="team">
            <div className="container my-4">
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-8 text-center">
                        <h2 className="section-title">Meet Our Team</h2>
                        <p className="lead">Passionate experts dedicated to your digital success</p>
                    </div>
                </div>
                <div className="row g-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="team-card card h-100">
                            <img src="https://nivesguru.in/shubhankar-das.webp" 
                                className="team-img" alt="Founder & CEO" />
                            {/* <img src="https://nivesguru.in/nivesguru-team-sylvia-b.webp"
                                className="team-img" alt="Founder & CEO" /> */}
                            <div className="card-body text-center">
                                <h4 className="mb-2">Shubhankar D</h4>
                                <p className="fw-bold">Co-Founder</p>
                                {/* <p className="small">Visionary leader driving strategic growth and innovation.</p> */}
                                <div className="team-social">
                                    <Link to="/"><i className="fab fa-linkedin-in"></i></Link>
                                    <Link to="/"><i className="fab fa-twitter"></i></Link>
                                    <Link to="/"><i className="fas fa-envelope"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="team-card card h-100">
                            <img src="https://nivesguru.in/nivesguru-team-priyankar-g.webp" 
                                className="team-img" alt="Digital Marketing Strategist" />
                            {/* <img src="https://nivesguru.in/shubhankar-das.webp"
                                className="team-img" alt="Founder & CEO" /> */}
                            <div className="card-body text-center">
                                <h4 className="mb-2">Rana Pratp S</h4>
                                <p className="fw-bold">Co-Founder</p>
                                {/* <p className="small">Expert in SEO, paid ads, and lead generation strategies.</p> */}
                                <div className="team-social">
                                    <Link to="/"><i className="fab fa-linkedin-in"></i></Link>
                                    <Link to="/"><i className="fab fa-twitter"></i></Link>
                                    <Link to="/"><i className="fas fa-envelope"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="team-card card h-100">
                            <img src="https://nivesguru.in/anupam.webp" 
                                className="team-img" alt="Creative Designer" />
                            {/* <img src="https://nivesguru.in/rahul.jpeg"
                                className="team-img" alt="Founder & CEO" /> */}
                            <div className="card-body text-center">
                                <h4 className="mb-2">Anupam M</h4>
                                <p className="fw-bold">Co-Founder</p>
                                {/* <p className="small">Crafting visual brand identities & UI/UX solutions.</p> */}
                                <div className="team-social">
                                    <Link to="/"><i className="fab fa-linkedin-in"></i></Link>
                                    <Link to="/"><i className="fab fa-twitter"></i></Link>
                                    <Link to="/"><i className="fas fa-envelope"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="team-card card h-100">
                            <img src="https://nivesguru.in/nivesguru-team-priyankar-g.webp" 
                                className="team-img" alt="AI & Automation Specialist" />
                            {/* <img src="https://nivesguru.in/hritick.webp"
                                className="team-img" alt="Founder & CEO" /> */}
                            <div className="card-body text-center">
                                <h4 className="mb-2">Anirudh M</h4>
                                <p className="fw-bold">Social Media Strategist</p>
                                {/* <p className="small">Optimizing marketing workflows through AI-driven insights.</p> */}
                                <div className="team-social">
                                    <Link to="/"><i className="fab fa-linkedin-in"></i></Link>
                                    <Link to="/"><i className="fab fa-twitter"></i></Link>
                                    <Link to="/"><i className="fas fa-envelope"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center mt-5">
                    <Link to="contact.html" className="btn btn-primary btn-lg">Work with our Team</Link>
                </div>
            </div>
        </section>
    );
};

export default Team;